import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch, parseJsonSafe } from '../utils/api';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const savedEmail = localStorage.getItem('savedEmail');
    const savedRemember = localStorage.getItem('rememberLogin') === 'true';
    if (savedEmail) setEmail(savedEmail);
    if (savedRemember) setRemember(true);
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await apiFetch('/api/branding');
        const data = await parseJsonSafe(res);
        if (active && data && data.company_logo) setLogo(data.company_logo);
      } catch (_e) { /* sin logo */ }
    })();
    return () => { active = false; };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await apiFetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await parseJsonSafe(res);

      if (!res.ok) {
        throw new Error(data.message || 'Error al iniciar sesión');
      }

      if (remember) {
        localStorage.setItem('savedEmail', email);
        localStorage.setItem('rememberLogin', 'true');
        localStorage.removeItem('savedPassword');
      } else {
        localStorage.removeItem('savedEmail');
        localStorage.removeItem('rememberLogin');
        localStorage.removeItem('savedPassword');
      }

      localStorage.setItem('token', data.token);
      if (data.user) {
        localStorage.setItem('role', data.user.role || 'user');
        localStorage.setItem('userEmail', data.user.email);
        if (data.user.modules) localStorage.setItem('modules', JSON.stringify(data.user.modules));
        else localStorage.removeItem('modules');
      }
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-login">
      <div className="app-login-brand">
        <div className="app-login-brand-inner">
          {logo
            ? <img src={logo} alt="INTERCONECTA" className="app-login-brand-logo" />
            : <p className="app-login-brand-wordmark">INTERCONECTA</p>}
          <h1 className="app-login-brand-claim">Panel de gestión INTERCONECTA</h1>
          <p className="app-login-brand-text">
            Clientes, comunicaciones, facturación y proyectos en un único lugar,
            potenciado por inteligencia artificial.
          </p>
        </div>
      </div>

      <div className="app-login-form-side">
        <div className="app-login-card">
          <div className="app-login-mobile-brand">
            {logo
              ? <img src={logo} alt="INTERCONECTA" className="app-login-mobile-logo" />
              : <p className="app-login-mobile-wordmark">INTERCONECTA</p>}
          </div>

          <h2 className="app-login-title">Iniciar sesión</h2>
          <p className="app-login-subtitle">Accede a tu panel de gestión</p>

          {error && <div className="app-login-alert" role="alert">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="app-login-field">
              <label className="app-login-label" htmlFor="app-login-email">Email</label>
              <input
                id="app-login-email"
                type="email"
                className="app-login-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                placeholder="tu@email.com"
              />
            </div>
            <div className="app-login-field">
              <label className="app-login-label" htmlFor="app-login-password">Contraseña</label>
              <input
                id="app-login-password"
                type="password"
                className="app-login-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                placeholder="Tu contraseña"
              />
            </div>
            <div className="app-login-remember">
              <input
                type="checkbox"
                id="rememberLogin"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              <label htmlFor="rememberLogin">Recordar credenciales</label>
            </div>
            <button type="submit" className="app-login-btn" disabled={loading}>
              {loading ? 'Ingresando...' : 'Iniciar sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
